import React from 'react';

const RootContext = React.createContext({});
export const RootProvider = RootContext.Provider;
export default RootContext;
